import api from './api';

/**
 * UAT test-environment notice endpoints. **UAT-only** — this module exists on the
 * `public-testing` branch and nowhere else.
 *
 * Deliberately a separate module rather than two more exports on `authService.js`.
 * CLAUDE.md says new feature endpoints go there, and normally they should; but
 * `authService.js` carries ~102 exports and is actively changed on `main`, so two
 * lines added to it would conflict on most future promotions of main → public-testing.
 * A new file conflicts with nothing. `scripts/uat/WORKFLOW.md` asks UAT-only edits to
 * live in files `main` does not touch, and that is what this is.
 *
 * Same axios instance as everything else, so the JWT is attached by the request
 * interceptor and no auth handling is needed here.
 */

/**
 * Whether the signed-in tester still has to sign, plus the notice itself when they do.
 * Returns `{ version, accepted, document }`; `document` is null once accepted.
 */
export const getUatTermsStatus = async () => {
  const response = await api.get('/auth/uat-terms');
  return response.data;
};

/**
 * Records a decision. `decision` is 'ACCEPTED' or 'DECLINED' — both are recorded, and
 * `signedName` is required for either, because on a shared tester account it is the
 * only record of which human was at the keyboard.
 *
 * `version` is echoed back from the status call so the server can reject a tab left
 * open across a deploy rather than record agreement to text nobody saw.
 */
export const acknowledgeUatTerms = async ({ version, signedName, decision }) => {
  const response = await api.post('/auth/uat-terms', { version, signedName, decision });
  return response.data;
};
